import type { AllCompaniesNames } from '../types/general';

import { Fishbrain } from './Fishbrain/Fishbrain';
import { Aspira } from './partners/Aspira/Aspira';

export const Companies: Record<AllCompaniesNames, () => React.JSX.Element> = {
  fishbrain: Fishbrain,
  aspira: Aspira,
};
